const stats = [
  { value: "500+", label: "Businesses Supported" },
  { value: "12+", label: "Years of Experience" },
  { value: "98%", label: "Client Satisfaction" },
  { value: "24/7", label: "Support Availability" },
];

export default function About() {
  return (
    <section id="about" className="py-24 bg-gray-900 text-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row gap-16 items-center">
          {/* Left: Image */}
          <div className="flex-shrink-0 w-full lg:w-[480px]">
            <div className="relative">
              <div className="w-full h-[420px] rounded-2xl overflow-hidden">
                <img
                  src="https://public.readdy.ai/ai/img_res/769226268059de4dbdd1aa2bb5ec2492.jpg"
                  alt="SilentNet Team"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              {/* Floating badge */}
              <div className="absolute -bottom-6 -right-6 bg-teal-500 rounded-2xl px-6 py-5 text-center">
                <div className="text-3xl font-extrabold text-white">12+</div>
                <div className="text-teal-100 text-xs mt-1">Years in IT</div>
              </div>
            </div>
          </div>

          {/* Right: Content */}
          <div className="flex-1">
            <span className="text-teal-400 text-xs font-semibold tracking-widest uppercase mb-4 block">
              About SilentNet
            </span>
            <h2 className="text-4xl md:text-5xl font-extrabold leading-tight mb-6">
              Your Trusted IT Partner,<br />
              <span className="text-teal-400">Built on Reliability</span>
            </h2>
            <p className="text-gray-400 text-base leading-relaxed mb-5">
              Founded with a mission to make enterprise-grade IT accessible to every business, SilentNet has grown into a full-service technology partner trusted by hundreds of organizations across the region.
            </p>
            <p className="text-gray-400 text-base leading-relaxed mb-10">
              Whether you need a quick remote fix or a complete infrastructure overhaul, our certified engineers bring the same level of dedication and expertise to every engagement. We don&apos;t just fix problems — we prevent them.
            </p>

            {/* Stats Grid */}
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 mb-10">
              {stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-3xl font-extrabold text-teal-400 mb-1">{stat.value}</div>
                  <div className="text-gray-500 text-xs leading-snug">{stat.label}</div>
                </div>
              ))}
            </div>

            {/* Certifications */}
            <div className="flex flex-wrap gap-3">
              {["Microsoft Certified", "CompTIA A+", "Cisco CCNA", "AWS Partner"].map((cert) => (
                <span
                  key={cert}
                  className="px-4 py-1.5 rounded-full border border-gray-700 text-gray-400 text-xs font-medium"
                >
                  {cert}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
